import React, { useState, useEffect } from "react";
// import "primereact/resources/primereact.min.css";
// import "primereact/resources/themes/lara-light-indigo/theme.css";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";

// import { NavLink } from "react-router-dom";
import { FilterMatchMode } from "primereact/api";
// import { InputText } from "primereact/inputtext";
// import { Button } from "primereact/button";
// import ButtonFeature from "../../features/Button.jsx";
import "primeicons/primeicons.css";
// import { IoChevronBackCircleOutline } from "react-icons/io5";
// import { AiFillEye, AiFillDelete } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
// import { TabView, TabPanel } from "primereact/tabview";
import { IoMdPaper } from "react-icons/io";
import instance from "../../api/api.js";
// import {Help} from "../../utils";
import { MenuPoint, ModalDelete } from "../../shared/compoments";
import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";
import { IoMdEye } from "react-icons/io";
import { MdEdit, MdOutlinePayment } from "react-icons/md";
import { statusConfig } from "../../utils";
import { styleIcone } from "../../shared";
import { AiOutlinePrinter } from "react-icons/ai";
import DatatableShared from "../../shared/compoments/DatatableShared";
import { useDispatch, useSelector } from "react-redux";
import { showModal, addItemInDataPrint } from "../../store/slice/PrintSlice";

function FactureList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const infoDataPrint = useSelector((state) => state.print.dataPrint);
  const OPTIONS = [
    {
      name: "Voir plus",
      icone: <IoMdEye style={styleIcone} />,
      isIdData: true,
      path: "/factures/",
    },
    {
      name: "Effecuter un paiement",
      icone: <MdOutlinePayment style={styleIcone} />,
      isIdData: true,
      isIdData: true,
      addMethodClick: true,
      // path: "/paiement-creation/5",
      methode: (idData) => {
        navigate(`/paiement-creation/${idData}`);
      },
    },
    {
      name: "Modifier",
      icone: <MdEdit style={styleIcone} />,
      isIdData: true,
      addMethodClick: false,
      path: "/factures/editer/",
    },
    {
      name: "Imprimer",
      icone: <AiOutlinePrinter style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
      methode: (idData) => {
        const element = factures.find((item) => item.id === idData);
        console.log("element", element);
        dispatch(addItemInDataPrint(element));
        dispatch(showModal());
      },
    },
  ];

  const INFO_COLUMN_TABLE = [
    {
      field: "created_at",
      header: "Date d'emission",
      body: (rowData) => {
        return <p>{new Date(rowData.created_at).toLocaleDateString("fr")}</p>;
      },
    },
    {
      field: "reference",
      header: "Référence",
    },
    {
      field: "statut",
      header: "Statut",
      body: (rowData) => {
        return (
          <span
            className="badge text-dark p-3 rounded-5"
            style={{
              background: statusConfig[rowData.statut],
            }}>
            {rowData.statut}
          </span>
        );
      },
    },
    {
      field: "type",
      header: "Nature",
    },
    {
      field: "id",
      header: "Période",
      body: (rowData) => {
        return rowData.date_debut ? (
          <p className="d-flex justify-content-center align-items-center place-items-center gap-3 flex-wrap">
            <span>{new Date(rowData.date_debut).toLocaleDateString("fr")}</span>
            <span>au</span>
            <span>{new Date(rowData.date_fin).toLocaleDateString("fr")}</span>
          </p>
        ) : (
          <p>Néant</p>
        );
      },
    },
    {
      field: "id",
      header: "Actions",
      body: (rowData) => {
        return (
          <MenuPoint
            optionMenu={OPTIONS}
            idData={rowData.id}
            statut={rowData.statut}
          />
        );
      },
    },
  ];

  const [factures, setFactures] = useState([]);
  const [facturesFilter, setFacturesFilter] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [verifIfIsClick, setVerifIfIsClick] = useState("Toutes");

  const ITEMSFILTER = ["reference", "type", "phone", "email"];
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    libelle: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    tarif: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    duree: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const getListOfFactures = async () => {
    try {
      const response = await instance.get("factures");
      console.log("getListOfFactures", response.data);
      setFactures(response.data.data);
      setFacturesFilter(response.data.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getListOfFactures();
  }, []);

  const filterFactureByImpayer = (e) => {
    const value = e.target.value;
    const elemntsFilter = facturesFilter.filter(
      (item) => item.statut === value
    );
    setFactures(elemntsFilter);
    setVerifIfIsClick(value);
    // factures.filter((item) => item.statut === value)
    console.log({
      value: value,
      FACTURES: factures,
      VerifIfIsClick: verifIfIsClick,
    });
  };
  const filterFactureByPayer = (e) => {
    const value = e.target.value;
    // setFactures(factures => );
    const elemntsFilter = facturesFilter.filter(
      (item) => item.statut === value
    );
    setFactures(elemntsFilter);
    setVerifIfIsClick(value);
    console.log({
      value: value,
      FACTURES: factures,
      VerifIfIsClick: verifIfIsClick,
    });
  };
  const filterFactureByAll = (e) => {
    const value = e.target.value;
    const elemntsFilter = facturesFilter.filter(
      (item) => item.statut !== value
    );
    setFactures(elemntsFilter);
    setVerifIfIsClick(value);
    console.log({
      value: value,
      FACTURES: factures,
      VerifIfIsClick: verifIfIsClick,
    });
  };

  return (
    <>
      <ModalDelete
        isPrintFacture={true}
        dataInfoForPrint={infoDataPrint}
        modalTitle={""}
        dataInfoForBtn={[
          {
            libelleBtn: "Oui",
            color: "error",
            methode: () => {
              console.log("dff");
              // if(isRejectedBtn){
              //   changeStatut('refuse',valueTextField)
              // }
              // if(!isRejectedBtn){
              //   changeStatut('accepter')
              // }
            },
          },
          {
            libelleBtn: "Non",
            isStyle: true,
            methode: () => {
              console.log("dff");
              // dispatch(showModal())
            },
          },
        ]}
      />
      <AllCompomentShared
        libelleHeaderComp={"Liste des factures"}
        titleStatisticHeaderComp={"Nombre de factures"}
        isBtnFilter
        btnFilterArray={[
          {
            libelle: "Toutes",
            methode: filterFactureByAll,
            isClickOn: verifIfIsClick,
          },
          {
            libelle: "impayer",
            methode: filterFactureByImpayer,
            isClickOn: verifIfIsClick,
          },
          {
            libelle: "payer",
            methode: filterFactureByPayer,
            isClickOn: verifIfIsClick,
          },
        ]}
        nbreTotalStatistiqueComp={factures.length}
        SearchTableIsSearch={true}
        placeholderInputSearch={"Recherche"}
        globalFilterValue={globalFilterValue}
        onGlobalFilterChange={onGlobalFilterChange}
        iconeStatistiqueHeader={<IoMdPaper fontSize={"2em"} />}
        isLoading={isLoading}>
        <DatatableShared
          ITEMSFILTER={ITEMSFILTER}
          filters={filters}
          items={factures}
          dataInfoColumn={INFO_COLUMN_TABLE}
        />
      </AllCompomentShared>
    </>
  );
}

export default FactureList;
